/**
 * Wait for a variable to be available in the global scope.
 * Useful after adding a script to the page, as it might take a while for the script to load.
 */
export const waitForVar = async (
  name: string,
  {
    pollFrequency = 1000,
    retries: inRetries = 100,
    parent = window,
  }: {
    pollFrequency?: number | (({ retries }: { retries: number }) => number);
    retries?: number;
    parent?: object;
  } = { pollFrequency: 1000, retries: 100, parent: window },
): Promise<unknown> => {
  // eslint-disable-next-line no-prototype-builtins
  if (parent && parent.hasOwnProperty(name)) {
    return Promise.resolve((parent as Record<string, unknown>)[name]);
  }
  if (!inRetries) {
    return Promise.resolve(undefined);
  }

  const retries = inRetries - 1;

  await new Promise((resolve) =>
    setTimeout(
      resolve,
      typeof pollFrequency === "function"
        ? pollFrequency({ retries })
        : pollFrequency,
    ),
  );

  return await waitForVar(name, { pollFrequency, parent, retries });
};
